import styled from "styled-components";
import COLORS from "../../../assets/Colors";

export const ProfileContainer = styled.div`
  background: ${COLORS.PRIMARY_WHITE};
  border-radius: 11px;
  max-width: 670px;
  margin: 20px 0px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 600px) {
    width: 90vw;
    padding: 30px 30px;
  }
`;
